module.exports = __webpack_public_path__ + "static/landingH-4c96ab3af99294402f576ae0325e0c8f.jpg";